// extracted by mini-css-extract-plugin
export default {"overlay__card":"Card_overlay__card__9JPQ7","card___":"Card_card_____OIR9O"};